import { useState, useEffect } from "react"
import { fetchMaintenanceWindow, isInMaintenanceWindow, shouldShowWarning } from "../../../useMaintenance"
import MaintenancePage from "./MaintenancePage"

const MaintenanceProvider = ({ children }) => {
  const [maintenanceData, setMaintenanceData] = useState(null)
  const [shouldRefresh, setShouldRefresh] = useState(false)

  const setupRefreshTimers = (data) => {
    if (!data || !data.start_time || !data.end_time) return

    const now = new Date()
    const startTime = new Date(data.start_time)
    const endTime = new Date(data.end_time)

    // Clear any existing timeouts
    window.maintenanceTimers?.forEach(timer => clearTimeout(timer))
    window.maintenanceTimers = []

    // Refresh when maintenance starts (1 minute after start time)
    if (now < startTime) {
      const timeUntilStart = startTime - now + 1000 // 1 minute buffer
      window.maintenanceTimers.push(
        setTimeout(() => setShouldRefresh(true), timeUntilStart)
      )
    }

    // Refresh when maintenance ends (1 minute after end time)
    if (now < endTime) {
      const timeUntilEnd = endTime - now + 1000 // 1 minute buffer
      window.maintenanceTimers.push(
        setTimeout(() => setShouldRefresh(true), timeUntilEnd)
      )
    }
  }

  const fetchData = async () => {
    try {
      const data = await fetchMaintenanceWindow()
      setMaintenanceData(data)
      setupRefreshTimers(data)
    } catch (error) {
      console.error("Error in MaintenanceProvider:", error)
    }
  }

  useEffect(() => {
    fetchData()
    const interval = setInterval(fetchData, 5 * 60 * 1000) // Check every 5 minutes
    return () => {
      clearInterval(interval)
      window.maintenanceTimers?.forEach(timer => clearTimeout(timer))
    }
  }, [])

  useEffect(() => {
    if (shouldRefresh) {
      window.location.reload()
    }
  }, [shouldRefresh])

  if (maintenanceData && isInMaintenanceWindow(maintenanceData)) {
    return <MaintenancePage maintenanceData={maintenanceData} />
  }

  return <>{children}</>
}

export default MaintenanceProvider